import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGraffa = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1000px",
	height: "1000px",
	viewBox: "0 0 1000 1000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 15" }), /* @__PURE__ */ _jsx("g", {
		id: "10.-Checker",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group-15",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "icon_Background",
				x: 0,
				y: 0,
				width: 1e3,
				height: 1e3
			}), /* @__PURE__ */ _jsxs("g", {
				id: "graffa",
				transform: "translate(166.666667, 277.777778)",
				children: [/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle-Copy-16",
					stroke: "#0056C1",
					strokeWidth: 28,
					x: 250.111111,
					y: 69.5555556,
					width: 194.222222,
					height: 305.333333
				}), /* @__PURE__ */ _jsx("path", {
					d: "M130.5,449 L130.5,417.5 L83,417.5 L83,292.5 C83,276.833333 78.5833333,262.916667 69.75,250.75 C60.9166667,238.583333 49.5,231.166667 35.5,228.5 L35.5,228.5 L35.5,220.5 C49.5,217.833333 60.9166667,210.416667 69.75,198.25 C78.5833333,186.083333 83,172.166667 83,156.5 L83,156.5 L83,31.5 L130.5,31.5 L130.5,0 L88.5,0 C75.1666667,0 65.1666667,3.91666667 58.5,11.75 C51.8333333,19.5833333 48.5,29.3333333 48.5,41 L48.5,41 L48.5,161 C48.5,175.333333 43.9166667,186.25 34.75,193.75 C25.5833333,201.25 14,205 0,205 L0,205 L0,244 C14,244 25.5833333,247.75 34.75,255.25 C43.9166667,262.75 48.5,273.666667 48.5,288 L48.5,288 L48.5,408 C48.5,419.666667 51.8333333,429.416667 58.5,437.25 C65.1666667,445.083333 75.1666667,449 88.5,449 L88.5,449 L130.5,449 Z M586.5,449 C599.833333,449 609.833333,445.083333 616.5,437.25 C623.166667,429.416667 626.5,419.666667 626.5,408 L626.5,408 L626.5,288 C626.5,273.666667 631.083333,262.75 640.25,255.25 C649.416667,247.75 661,244 675,244 L675,244 L675,205 C661,205 649.416667,201.25 640.25,193.75 C631.083333,186.25 626.5,175.333333 626.5,161 L626.5,161 L626.5,41 C626.5,29.3333333 623.166667,19.5833333 616.5,11.75 C609.833333,3.91666667 599.833333,0 586.5,0 L586.5,0 L544.5,0 L544.5,31.5 L592,31.5 L592,156.5 C592,172.166667 596.416667,186.083333 605.25,198.25 C614.083333,210.416667 625.5,217.833333 639.5,220.5 L639.5,220.5 L639.5,228.5 C625.5,231.166667 614.083333,238.583333 605.25,250.75 C596.416667,262.916667 592,276.833333 592,292.5 L592,292.5 L592,417.5 L544.5,417.5 L544.5,449 L586.5,449 Z",
					id: "{}",
					fill: "#424548",
					fillRule: "nonzero"
				})]
			})]
		})
	})]
});
export default SvgGraffa;
